import { createSelector } from '@ngrx/store';
import { getLocationDetails } from '../../../locations/selectors';

export const getVirtualLocationsForPhysicalLocation = (locationNo: Nullable<number>) =>
    createSelector(getLocationDetails(locationNo), (locationDetails) => locationDetails?.VirtualLocations);
